import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row } from '../../atoms';
import { PaginationRange } from './range';
import { PaginationControl } from './control';
export function Pagination({ page, pageSize, totalCount, totalPages, onPressPage, }) {
    return (_jsxs(Row.LR, { children: [_jsx(PaginationRange, { perPage: pageSize, totalCount: totalCount }), _jsx(PaginationControl, { onPress: onPressPage, page: page, totalPages: totalPages })] }));
}
